import React from 'react';
import { IFiscalBenefit } from '../../../../../../store/ducks/long-steel-shopping-cart/types';
import { Select } from '@gerdau/hefesto/Select';
interface IFiscalBenefitSelectProps {
  fiscalBenefits: IFiscalBenefit[];
  selectedFiscalBenefit: string;
  onSelectFiscalBenefit(code: string): void;
}

const FiscalBenefitSelect: React.FC<IFiscalBenefitSelectProps> = ({
  fiscalBenefits,
  selectedFiscalBenefit,
  onSelectFiscalBenefit
}) => {
  const fiscalBenefitsOptions = fiscalBenefits.map((fiscalBenefit) => ({
    label: fiscalBenefit.code,
    value: fiscalBenefit.code
  }));

  return (
    <Select
      label=""
      hideLabel
      name="benefitSelect"
      options={fiscalBenefitsOptions}
      value={selectedFiscalBenefit}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onSelect={(selectedFiscalBenefitOption: any) =>
        onSelectFiscalBenefit(selectedFiscalBenefitOption)
      }
    />
  );
};

export default FiscalBenefitSelect;
